import * as React from "react";

const SvgComponent = ({ color = "#fff", ...props }) => (
  <svg
    width={19}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.125.125a9 9 0 1 0 9 9 9.008 9.008 0 0 0-9-9Zm0 16.88a7.88 7.88 0 1 1 7.88-7.88 7.888 7.888 0 0 1-7.88 7.88Zm1.04-8.844v4.617a.374.374 0 0 1-.373.374H8.458a.373.373 0 0 1-.373-.373V8.16c0-.207.167-.374.373-.374h1.334a.374.374 0 0 1 .373.374Zm0-2.688v.981a.373.373 0 0 1-.373.374H8.458a.373.373 0 0 1-.373-.374v-.983c0-.206.167-.373.373-.373h1.334a.374.374 0 0 1 .373.373v.002Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;